export default __webpack_public_path__ + "static/media/kitchen3-afterJ-1920w.4ed24154.avif";